import axios from "axios";

// const API_BASE_URL = "https://api.buyandwin.in/api/";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:8080/api/";


const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
});

axiosInstance.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  else delete config.headers.Authorization;
  return config;
});

export default axiosInstance;
